import { BooleanInput } from '@angular/cdk/coercion';
import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  computed,
  input,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { QuicklinkDirective } from 'ngx-quicklink';
import { Card } from '../card/card.component';

type WarningCardType =
  | 'information'
  | 'warning'
  | 'critical'
  | 'success'
  | 'disclosure';

const WARNING_CARD_ICON_BY_TYPE: Record<WarningCardType, string> = {
  information: 'info',
  warning: 'warning',
  critical: 'error',
  success: 'check_circle',
  disclosure: 'mail_outline',
};

@Component({
  selector: 'procure-warning-card',
  templateUrl: './warning-card.component.html',
  styleUrl: './warning-card.component.scss',
  imports: [Card, MatIcon, RouterLink, QuicklinkDirective, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningCard {
  readonly routerLink = input<string[]>();
  readonly type = input<WarningCardType>('warning');
  readonly noMargin = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });
  readonly icon = computed(() => WARNING_CARD_ICON_BY_TYPE[this.type()]);
}
